import { render } from "./CreateEditStaff.vue?vue&type=template&id=16761377"
import script from "./CreateEditStaff.vue?vue&type=script&lang=js"
export * from "./CreateEditStaff.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__